module.exports = __webpack_public_path__ + "static/media/arrow_close.eb5635d6.svg";